import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { WordsPullUp, SectionLabel } from '@/components/animations';

const PARTNERS = ['Samsung', 'Meta', 'PlayStation', 'Nvidia', 'Armani', 'Nespresso', 'Best Buy', 'Seedance 2.0', 'Coinbase'];

/**
 * Partnerships — not a form. A composed page with the partner roster and a
 * direct contact email instead of an inquiry flow.
 */
export const WorkCard = ({ active }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={active ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
    transition={{ duration: 0.9, ease: 'easeOut' }}
    className="relative w-[min(640px,90vw)] text-center"
    data-testid="work-card"
  >
    <SectionLabel className="!text-center">Partnerships</SectionLabel>
    <h2
      className="text-4xl sm:text-6xl text-cream leading-[1.04]"
      style={{ fontFamily: "'IM Fell English', serif" }}
    >
      <WordsPullUp text="Let's build something together." active={active} />
    </h2>
    <p className="mx-auto mt-4 max-w-[34rem] text-sm sm:text-base text-cream/70">
      Brand partnerships, campaigns, and collaborations — across tech, AI, and gaming.
    </p>
    <motion.p
      initial={{ opacity: 0 }}
      animate={active ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 1, delay: 0.5 }}
      className="mt-6 font-mono-label text-[10px] sm:text-xs uppercase tracking-[0.28em] text-cream/45"
    >
      {PARTNERS.join('   ·   ')}
    </motion.p>
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={active ? { opacity: 1, y: 0 } : { opacity: 0, y: 14 }}
      transition={{ duration: 0.8, delay: 0.75, ease: 'easeOut' }}
      className="mt-9 flex flex-col items-center gap-3"
    >
      <Button asChild variant="cream" size="pill" data-testid="work-email-btn">
        <a href="mailto:joe@rakugomedia.com">
          <Mail />
          joe@rakugomedia.com
        </a>
      </Button>
    </motion.div>
  </motion.div>
);
